import { atom } from "jotai";

export type ThemePrefs = {
  fontFamily: "Geist" | "OpenDyslexicRegular";
  radius: "xs" | "sm" | "md" | "lg" | "xl";
  focusRing: "auto" | "always" | "never";
  luminanceThreshold: number;
  scale: number;
  autoContrast: boolean;
  colors: {
    primary: Color;
  };
};

type Color =
  | "blue"
  | "gray"
  | "red"
  | "pink"
  | "grape"
  | "violet"
  | "indigo"
  | "cyan"
  | "teal"
  | "green"
  | "lime"
  | "yellow"
  | "orange";

// Non-persistent atom (safe for SSR)
// ⛔ No localStorage: we avoid using atomWithStorage to prevent hydration mismatches and UI flashes.
// ✅ SSR-safe: This atom is in-memory only, fast and fully compatible with Vike SSR.
// 💡 If persistence is required later, load/save the prefs from Supabase as shown in https://vike.dev/store

export const themeAtom = atom<ThemePrefs>({
  fontFamily: "Geist",
  radius: "sm",
  colors: {
    primary: "blue",
  },
  focusRing: "auto",
  luminanceThreshold: 0.03,
  autoContrast: false,
  scale: 1,
});
